import { Button, CircularProgress, IconButton } from '@material-ui/core'
import { ERROR_COLORS, GRAY_COLORS, SUCCESS_COLORS } from 'asterX-UI'
import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { CloseIcon, SuccessCreditIcon } from 'asterX-UI/Icons'
import ChipStandard from 'asterX-UI/DataDisplay/ChipStandard'
import { Modal } from 'asterX-UI/Modals'
import { CarService } from 'lib/api'
import { useResErrors } from 'hooks'
import moment from 'moment'
import CarSelectionCard from './Car/CarSelectionCard'
import PageContainerDesktop from 'components/PageContainer/layout/PageContainer.desktop'

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    marginBottom: 20
  },
  heading: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    marginRight: 'auto'
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    marginBottom: 32
  },
  pair: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    gap: 3,
    fontSize: 14,
    minWidth: '40%'
  },
  row: {
    display: 'flex',
    gap: 60,
    '&:nth-child(1)': {
      minWidth: '140px'
    }
  },
  label: {
    color: GRAY_COLORS['400']
  },
  text: {
    color: GRAY_COLORS['700']
  },
  creditApproved: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    fontSize: 12,
    color: SUCCESS_COLORS['700'],
    padding: '8px 2px',
    backgroundColor: SUCCESS_COLORS['50']
  }
}))
/* val createdDate: String? = null
  val iin: String? = null
  val responseCode: String? = null
  val responseDesc: String? = null
  val productCode: String? = null
  val creditSum: String? = null
  val creditTerm: String? = null
  val monthlyPaymentAmount: String? = null
  val initialFee: String? = null*/

const CreditApprovalModal = ({ creditRequest, loadCreditRequest = false }) => {
  const { silentCheck } = useResErrors()
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const [carList, setCarList] = useState([])

  const onSearchCar = async productCode => {
    await CarService.getCarList(
      {
        oneCId: productCode
      },
      0,
      2
    ).then(res =>
      silentCheck(res, () => {
        setCarList(res.data.listCars)
      })
    )
  }
  const getByLabel = creditorCode => {
    switch (creditorCode) {
      case 'EVRAZ':
        return 'Евразийский банк'
      case 'JETCAR':
        return 'JETCAR'
      default:
        return creditorCode
    }
  }
  const getByStatus = status => {
    if (status === 'Предварительно отказано') {
      return { label: 'Одобрено', color: ERROR_COLORS }
    }
    if (status === 'Предварительно одобрено') {
      return { label: 'Одобрено', color: SUCCESS_COLORS }
    }
    if (status === 'Одобрение') {
      return { label: 'Одобрено', color: SUCCESS_COLORS }
    }
    return { label: 'Нет заявки', color: GRAY_COLORS }
  }

  const status = getByStatus(creditRequest?.responseCode)

  useEffect(() => {
    if (!!creditRequest?.productCode) {
      const code = creditRequest?.productCode.substring(1)
      onSearchCar(code)
    }
  }, [])

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10
        }}
      >
        {loadCreditRequest ? (
          <CircularProgress color={'primary'} size={20} />
        ) : (
          <ChipStandard
            {...{
              backgroundColor: status?.color[50],
              color: status?.color[700]
            }}
            onClick={() => creditRequest?.responseCode && setOpen(true)}
          >
            {status?.label}
          </ChipStandard>
        )}
      </div>
      {open && (
        <Modal open={open} fullWidth>
          <PageContainerDesktop
            customHeader={
              <div className={classes.header}>
                <div className={classes.heading}>Онлайн кредит</div>
                <IconButton
                  style={{
                    color: GRAY_COLORS[400]
                  }}
                  onClick={() => setOpen(false)}
                  size={'medium'}
                >
                  <CloseIcon />
                </IconButton>
              </div>
            }
          >
            <div className={classes.info}>
              <div className={classes.row}>
                <div className={classes.pair}>
                  <div className={classes.text}>
                    {getByLabel(creditRequest?.creditorCode)}
                  </div>
                </div>
                <ChipStandard
                  color={SUCCESS_COLORS['700']}
                  backgroundColor={SUCCESS_COLORS['50']}
                >
                  <SuccessCreditIcon />
                  Одобрено
                </ChipStandard>
              </div>
              <div className={classes.pair}>
                <div className={classes.label}>ФИО</div>
                <div className={classes.text}>
                  {`${creditRequest?.firstName || ''} ${
                    creditRequest?.lastName || ''
                  } ${creditRequest?.middleName || ''}`}
                </div>
              </div>
              <div className={classes.row}>
                <div className={classes.pair}>
                  <div className={classes.label}>ИНН</div>
                  <div className={classes.text}>{creditRequest?.iin}</div>
                </div>
                <div className={classes.pair}>
                  <div className={classes.label}>Дата заявки</div>
                  <div className={classes.text}>
                    {moment(
                      creditRequest?.createdDate ||
                        creditRequest?.dataUploadedAt
                    ).format('DD MMM YYYY')}
                  </div>
                </div>
              </div>
              <div className={classes.row}>
                <div className={classes.pair}>
                  <div className={classes.label}>Срок кредита</div>
                  <div className={classes.text}>{creditRequest?.term}</div>
                </div>
                <div className={classes.pair}>
                  <div className={classes.label}>ПВ</div>
                  <div className={classes.text}>
                    {creditRequest?.initialPayment}
                  </div>
                </div>
              </div>
              <div className={classes.row}>
                <div className={classes.pair}>
                  <div className={classes.label}>Сумма займа</div>
                  <div className={classes.text}>{creditRequest?.amount}</div>
                </div>
              </div>
              <div className={classes.row}>
                {!!carList ? (
                  carList?.map(car => <CarSelectionCard car={car} />)
                ) : (
                  <div className={classes.label}>Авто отсутствует</div>
                )}
              </div>
            </div>
            <Button
              variant={'contained'}
              color={'primary'}
              fullWidth
              onClick={() => setOpen(false)}
            >
              Закрыть
            </Button>
          </PageContainerDesktop>
        </Modal>
      )}
    </>
  )
}

export default CreditApprovalModal
